export default "__VITE_ASSET__bd3609de__"